import { TableLandingBorrowComponent } from "../../components/borrowSystem/TableLandingBorrowComponent";
import { HeadTitle } from "../../components/share/HeadTitle";
import { Footer } from "../../components/share/Footer";
import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";

export function TableLandingBorrowContainer() {
  const title = "รายการคำขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={title}></HeadTitle>
      <TableLandingBorrowComponent />
      <Footer />
    </div>
  );
}
